/**
 * Store pour les statistiques des publications de l'utilisateur connecté
 */

import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import axios from '@js/tools/axios';
/***/
import { useManagingUser } from '@compositions/ManagingUser';

export const useAuthPublicationStatisticsStore = defineStore('authPublicationStatistics', (() => {

    // Composition pour l'utilisateur que l'on gère
    const { getManagingUser } = useManagingUser({});

    // State des données de la liste des statistiques des publications
    const publicationsStatisticsList = ref({});

    // Retourne les données des statistiques des publications
    const getPublicationsStatisticsList = computed(() => publicationsStatisticsList.value);

    /**
     * Chargement des statistiques des publications de l'utilisateur connecté
     * @param Object params
     * @return Promise
     */
    const loadPublicationsStatistics = ((params) => {

        const userId = getManagingUser.value.id;

        const path = `/api/users/${ userId }/tasks/publications/statistics`;

        return axios.get(path, {
            params: params
        }).then((response) => {
            if(response && response.data && response.data.success && response.data.data) {
                if(params.offset === 0) {
                    resetPublicationsStatisticsList();
                }

                updatePublicationsStatisticsList(response.data.data);

                return Promise.resolve();
            }
            return Promise.reject();
        });

    });

    /**
     * Modifie la liste des statistiques des publications dans le store
     * @param data Données des templates : total et items
     * @return void
     */
    const updatePublicationsStatisticsList = ((data) => {

        const currentData = publicationsStatisticsList.value;

        if(currentData.total === undefined) {
            publicationsStatisticsList.value = {
                total: data.total,
                items: data.items
            };

        } else {
            publicationsStatisticsList.value.total = data.total;

            const currentItems = publicationsStatisticsList.value.items;
            const newItems = data.items.filter((item) => ! currentItems.find((current) => current.id === item.id));
            publicationsStatisticsList.value.items = [ ...currentItems, ...newItems ];
        }

    });

    /**
     * Réinitialisation de la liste des statistiques
     * @return void
     */
    const resetPublicationsStatisticsList = (() => {
        publicationsStatisticsList.value = {};
    });

    return {
        getPublicationsStatisticsList,
        loadPublicationsStatistics,
        resetPublicationsStatisticsList
    };
}));


